import React from "react";

import ExternalLink from "@/components/shared/ExternalLink";

import docRoutes from "./docRoutes";

function DocLink({
  anchor = "",
  route,
  text,
}: {
  anchor?: string;
  route: keyof typeof docRoutes;
  text: string;
}) {
  return <ExternalLink isExternal display="inline-block" href={docRoutes[route] + anchor} text={text} />;
}

export default DocLink;
